var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提示",
        visible: _vm.dialogVisible,
        width: "640px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { attrs: { id: "print" } }, [
        _c(
          "table",
          { staticClass: "gh-table" },
          [
            _c("thead", [
              _c("tr", [
                _c(
                  "th",
                  { staticStyle: { padding: "0" }, attrs: { colspan: "24" } },
                  [_vm._v("零售单")]
                ),
              ]),
              _c("tr", [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("仓库名称：")]),
                _c("td", { attrs: { colspan: "20" } }, [
                  _vm._v(_vm._s(_vm.data.positionName)),
                ]),
              ]),
              _c("tr", [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("单据时间：")]),
                _c("td", { attrs: { colspan: "20" } }, [
                  _vm._v(_vm._s(_vm.data.ordTime)),
                ]),
              ]),
              _c("tr", [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("用户名称：")]),
                _c("td", { attrs: { colspan: "20" } }, [
                  _vm._v(_vm._s(_vm.data.inTypeName)),
                ]),
              ]),
              _c("tr", { staticClass: "fixed-header" }, [
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("药品编码")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("药品名称")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("品质")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("规格")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("剂型")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("销售数量")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("销售单价")]),
                _c("th", { attrs: { colspan: "3" } }, [_vm._v("销售金额")]),
              ]),
            ]),
            _vm._l(_vm.list, function (value, index) {
              return _c("tbody", { key: index }, [
                _c("tr", [
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.materielCode)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.materielName)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.toJson(_vm.jsonStr.qualitySign, value.qualitySign)
                      )
                    ),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.medSpecName)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.medDosageName)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.sellingNum)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.salePrice)),
                  ]),
                  _c("td", { attrs: { colspan: "3" } }, [
                    _vm._v(_vm._s(value.saleAmount)),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { attrs: { colspan: "4" } }, [_vm._v("用药天数：")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _vm._v(_vm._s(value.dayNum)),
                  ]),
                  _c("td", { attrs: { colspan: "4" } }, [_vm._v("每日次数：")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _vm._v(_vm._s(value.dayFreq)),
                  ]),
                  _c("td", { attrs: { colspan: "4" } }, [_vm._v("每次剂量：")]),
                  _c("td", { attrs: { colspan: "4" } }, [
                    _vm._v(_vm._s(value.freqNum)),
                  ]),
                ]),
                _c("tr", { attrs: { rowspan: "2" } }, [
                  _c("td", { attrs: { colspan: "4" } }, [_vm._v(" 医嘱 ")]),
                  _c("td", { attrs: { colspan: "20" } }, [
                    _vm._v(" " + _vm._s(value.medAdvice) + " "),
                  ]),
                ]),
              ])
            }),
            _c("tfoot", [
              _c("tr", [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("总价合计：")]),
                _c(
                  "th",
                  {
                    staticStyle: { "text-align": "start" },
                    attrs: { colspan: "20" },
                  },
                  [_vm._v(_vm._s(_vm.data.saleAmount))]
                ),
              ]),
              _c("tr", [
                _c("th", { attrs: { colspan: "4" } }, [_vm._v("签字：")]),
                _c("th", { attrs: { colspan: "20" } }),
              ]),
            ]),
          ],
          2
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handlePrint } },
            [_vm._v("打 印")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }